import { render } from "./TableProject.vue?vue&type=template&id=0ea4bcb7&scoped=true"
import script from "./TableProject.vue?vue&type=script&lang=js"
export * from "./TableProject.vue?vue&type=script&lang=js"

import "./TableProject.vue?vue&type=style&index=0&id=0ea4bcb7&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea4bcb7"]])

export default __exports__